const qs = require("qs");

export default function qsStringify(query) {
  return qs.stringify(
    {
      ...query,
    },
    {
      encodeValuesOnly: true, // prettify URL
    },
  );
}
